export default "__VITE_ASSET__fMKYlC8b__"